import React, { useState } from "react";
import OrganizationTab from "../Profile/OrganizationTab";
import ProfileTab from "../Profile/ProfileTab";
import TeamTab from "../Profile/TeamTab";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";
import BasicDetails from "../Profile/BasicDetails";
export default function Dashboard() {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    {
      name: "Profile",
      tabItem: <ProfileTab />
    },
    {
      name: "Organization",
      tabItem: <OrganizationTab />
    },
    /* {
      name: "Team",
      tabItem: <TeamTab />
    } */
  ];

  const handleToggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  return (
    <div className="profileCard">
      <BasicDetails />
      <div className="profileDetailsPanel">
        <Nav tabs className="profileDetails-tab">
          {tabs.map((tab, idx) => (
            <NavItem className="c-pointer" key={idx}>
              <NavLink
                className={classnames({
                  active: activeTab === idx
                })}
                onClick={() => {
                  handleToggleTab(idx);
                }}
              >
                {tab.name}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeTab} id="profile-tabContent">
          {tabs.map((tab, idx) => (
            <TabPane key={idx} tabId={idx}>
              {tab.tabItem}
            </TabPane>
          ))}
        </TabContent>
      </div>
    </div>
  );
}
